import { useCreateStateV2TOHMutation } from "../../core/api/toh-state-api"
import {
    useGetSyncConflictTOHQuery,
    useGetSyncConflictsTOHQuery
} from "../../core/api/toh-sync-conflicts-api"
import SyncConflictsPage from "./SyncConflictsPage"

export default function SyncConflictsTOH({ game = "toh" }) {
    const [createState, createStateResult] = useCreateStateV2TOHMutation()

    return (
        <SyncConflictsPage
            game={game}
            useListQuery={useGetSyncConflictsTOHQuery}
            useDetailQuery={useGetSyncConflictTOHQuery}
            createState={createState}
            createStateResult={createStateResult}
        />
    )
}
